<template>
  <div class="index" v-cloak style="background-color: #f2f2f2">
    <div class="header acea-row acea-row-back row-center-wrapper">
      <div class="dingwei"><span></span>{{ city }}</div>
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索商品
      </router-link>
      <router-link v-if="!isDaySign" :to="'/user/sign'"
        ><div class="qiandao"></div
      ></router-link>
      <router-link v-if="isDaySign" :to="'/user/sign'"
        ><div class="yiqiandao"></div
      ></router-link>
    </div>
   <!-- <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <router-link
            :to="item.url ? item.url : ''"
            class="search acea-row row-middle"
          >
            <img :src="item.pic" />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>-->

    <div class="nav acea-row list lianjie">
      <router-link class="item"
              :to="{
              path: '/category'

            }"
              >
        <div class="pictrue">
          <img src="@assets/images/ranqizao.png" />
        </div>
        <div class="business">燃气灶</div>
      </router-link>
      <router-link class="item"
                   :to="{
              path: '/category'

            }"
      >
        <div class="pictrue">
          <img src="@assets/images/yanji.png" />
        </div>
        <div class="business">烟机</div>
      </router-link>
      <router-link class="item"
                   :to="{
              path: '/category'

            }"
      >
        <div class="pictrue">
          <img src="@assets/images/reshuiqi.png" />
        </div>
        <div class="business">热水器</div>
      </router-link>
      <router-link class="item"
                   :to="{
              path: '/category'

            }"
      >
        <div class="pictrue">
          <img src="@assets/images/bigualu.png" />
        </div>
        <div class="business">壁挂炉</div>
      </router-link>
      <router-link class="item"
                                    :to="{
              path: '/category'

            }"
    >
      <div class="pictrue">
        <img src="@assets/images/boweng.png" />
      </div>
      <div class="business">波纹管</div>
    </router-link>
      <router-link class="item"
                   :to="{
              path: '/category'
            }"
      >
        <div class="pictrue">
          <img src="@assets/images/baojingqi.png" />
        </div>
        <div class="business">报警器</div>
      </router-link>
      <router-link class="item"
                   :to="{
              path: '/category'
            }"
      >
          <!-- <div class="pictrue">
           <img src="@assets/images/liangyou.png" />
         </div>
       <div class="business">粮油</div>-->
          <div class="pictrue">
          <img src="@assets/images/bn.png" />
        </div>
       <div class="business">物联网表</div>
      </router-link>
        <router-link class="item"
                     :to="{
              path: '/category'
            }"
        >
            <!--<div class="pictrue">
                <img src="@assets/images/lifeServe.png" />
            </div>
            <div class="business">生活服务</div>-->
            <div class="pictrue">
                <img src="@assets/images/fm.png" />
            </div>
            <div class="business">自闭阀</div>
        </router-link>
    </div>
  <!--  <div class="news acea-row row-between-wrapper">
      <div class="pictrue1">
        &lt;!&ndash;<img src="@assets/images/news.png" />&ndash;&gt;
        <span class="iconfont icon-huabanfuben"></span>
      </div>
      &lt;!&ndash;<div class="swiper-no-swiping new-banner" v-if="roll.length <= 1">&ndash;&gt;
      &lt;!&ndash;<swiper class="swiper-wrapper"&ndash;&gt;
      &lt;!&ndash;:options="swiperRoll"&ndash;&gt;
      &lt;!&ndash;&gt;&ndash;&gt;
      &lt;!&ndash;<swiper-slide&ndash;&gt;
      &lt;!&ndash;class="swiper-slide"&ndash;&gt;
      &lt;!&ndash;v-for="(item, index) in roll"&ndash;&gt;
      &lt;!&ndash;:key="index">&ndash;&gt;
      &lt;!&ndash;<router-link :to="item.url ? item.url : ''"&ndash;&gt;
      &lt;!&ndash;class="acea-row row-between-wrapper ">&ndash;&gt;
      &lt;!&ndash;<div class="text acea-row row-between-wrapper">&ndash;&gt;
      &lt;!&ndash;<div class="label" v-if="item.show === '是'">最新</div>&ndash;&gt;
      &lt;!&ndash;<div class="newsTitle line1">{{ item.info }}</div>&ndash;&gt;
      &lt;!&ndash;</div>&ndash;&gt;
      &lt;!&ndash;<div class="iconfont icon-xiangyou"></div>&ndash;&gt;
      &lt;!&ndash;</router-link>&ndash;&gt;
      &lt;!&ndash;</swiper-slide>&ndash;&gt;
      &lt;!&ndash;</swiper>&ndash;&gt;
      &lt;!&ndash;</div>&ndash;&gt;
      <div class="swiper-no-swiping new-banner">
        <swiper
          class="swiper-wrapper"
          :options="swiperRoll"
          v-if="roll.length > 0"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in roll"
            :key="index"
          >
            <router-link
              :to="item.url ? item.url : ''"
              class="acea-row row-between-wrapper "
            >
              <div class="text acea-row row-between-wrapper">
                <div class="label" v-if="item.show === '是'">最新</div>
                <div class="newsTitle line1">{{ item.info }}</div>
              </div>
              <div class="iconfont icon-xiangyou"></div>
            </router-link>
            <router-link
              :to="item.url ? item.url : ''"
              class="acea-row row-between-wrapper "
              v-if="roll.length > 1"
            >
              <div class="text acea-row row-between-wrapper">
                <div class="label" v-if="item.show === '是'">最新</div>
                <div class="newsTitle1 line1">{{ item.info }}</div>
              </div>
              <div class="iconfont icon-xiangyou"></div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>


    </div>-->
   <!-- <div class="nav1 acea-row">
      <router-link
        :to="item.url ? item.url : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"
      >
        <div class="pictrue">
          <img :src="item.pic" />
        </div>
        &lt;!&ndash;<div>{{ item.name }}</div>&ndash;&gt;
      </router-link>
    </div>-->
      <div class="nav1 acea-row" style="background-color: #ffffff;border-radius: 0.2rem;margin: 2%">
          <router-link to="/storeapply" class="item1">
              <div class="pictrue1" style="margin-left: 5%;">
                  <img src="@assets/images/guanggao.png" />
              </div>
          </router-link>
          <router-link
                  :to="menus[0].url ? menus[0].url : ''"
                  class="item"
          >
              <div class="pictrue" style="float: left;height: 2.5rem;width: 110%;margin: 8%;">
                  <img :src="menus[0].pic" />
              </div>
          </router-link>
          <router-link
                  :to="menus[1].url ? menus[1].url : ''"
                  class="item"
          >
              <div class="pictrue" style="width: 160%;height: 41%;margin-left: 29%;margin-top: 8%;">
                  <img :src="menus[1].pic" />
              </div>
          </router-link>
          <br/>
          <router-link
                  :to="menus[2].url ? menus[2].url : ''"
                  class="item"
          >
              <div class="pictrue" style="    width: 160%;height: 41%;margin-left: -70%;margin-top: 65%;">
                  <img :src="menus[2].pic" />
              </div>
          </router-link>
      </div>
    <div class="hotList" v-if="huaweiClub.length > 0">

      <div
        class="list acea-row row-middle"
        style="background-image: linear-gradient(to right ,#fe01a9 0%,#b043f6 100%);"
      >
        <div class="hot-bg">
          <div class="title acea-row row-between-wrapper">
            <div class="text line1">
              <span class="label huawei">华为馆</span>
            </div>
            <router-link :to="{ path: '/huawei_class/7' }" class="more">
              更多
              <span class="iconfont icon-jiantou"></span>
            </router-link>
          </div>
        </div>
        <router-link
          :to="{ path: '/detail/' + item.id }"
          class="item"
          v-for="(item, index) in huaweiClub"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.image" />
          </div>
          <div class="name line1">{{ item.storeName }}</div>
          <div class="money font-color-red">
            ￥
            <span class="num">{{ item.price }}</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="hotList" v-if="likeInfo.length > 0">
        <div>
            <div class="hot-bg">
                <div class="title acea-row row-between-wrapper">
                    <div class="text line1">
                        <span class="label ">燃气产品</span>
                    </div>
                    <router-link :to="{ path: '/hot_new_goods/' + 2 }" class="more">
                        更多
                        <span class="iconfont icon-jiantou"></span>
                    </router-link>
                </div>
            </div>
        </div>
      <div class="list acea-row row-middle">
        <router-link
          :to="{ path: '/detail/' + item.id }"
          class="item"
          v-for="(item, index) in likeInfo"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.image" />
          </div>
          <div class="name line1">{{ item.storeName }}</div>
          <div class="money font-color-red">
            ￥
            <span class="num">{{ item.price }}</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="hotList" v-if="produceInfo.length > 0">
      <div>
        <div class="hot-bg">
          <div class="title acea-row row-between-wrapper">
            <div class="text line1">
              <span class="label people">其他服务</span>
            </div>
            <router-link :to="{ path: '/hot_new_goods/' + 5 }" class="more">
              更多
              <span class="iconfont icon-jiantou"></span>
            </router-link>
          </div>
        </div>
      </div>
        <div class="list acea-row row-middle">
            <router-link
                :to="{ path: '/detail/' + item.id }"
                class="item"
                v-for="(item, index) in produceInfo"
                :key="index"
        >
            <div class="pictrue">
                <img :src="item.image" />
            </div>
            <div class="name line1">{{ item.storeName }}</div>
            <div class="money font-color-red">
                ￥
                <span class="num">{{ item.price }}</span>
            </div>
         </router-link>
        </div>
     </div>

    <div class="hotList" v-if="serveInfo.length > 0">
      <div>
        <div class="hot-bg">
          <div class="title acea-row row-between-wrapper">
            <div class="text line1">
              <span class="label apple">城燃超市</span>
            </div>
            <router-link :to="{ path: '/hot_new_goods/' + 6 }" class="more">
              更多
              <span class="iconfont icon-jiantou"></span>
            </router-link>
          </div>
        </div>
      </div>
          <div class="list acea-row row-middle">
              <router-link
                      :to="{ path: '/detail/' + item.id }"
                      class="item"
                      v-for="(item, index) in serveInfo"
                      :key="index"
              >
                  <div class="pictrue">
                      <img :src="item.image" />
                  </div>
                  <div class="name line1">{{ item.storeName }}</div>
                  <div class="money font-color-red">
                      ￥
                      <span class="num">{{ item.price }}</span>
                  </div>
              </router-link>
          </div>
    </div>

    <!--   <div class="wrapper" v-if="bastList.length > 0">
         <div class="title acea-row row-between-wrapper">
           <div class="text">
             <div class="name line1">
               精品推荐
               <span class="new font-color-red">FINE~</span>
             </div>
           </div>
           <router-link :to="{ path: '/hot_new_goods/' + 1 }" class="more">
             更多
             <span class="iconfont icon-jiantou"></span>
           </router-link>
         </div>
         <Good-list :good-list="bastList" :is-sort="false"></Good-list>
       </div>-->
    <!-- <div class="wrapper" v-if="firstList.length > 0">
       <div class="title acea-row row-between-wrapper">
         <div class="text">
           <div class="name line1">
             首发新品
             <span class="new font-color-red">NEW~</span>
           </div>
         </div>
         <router-link :to="{ path: '/hot_new_goods/' + 3 }" class="more">
           更多
           <span class="iconfont icon-jiantou"></span>
         </router-link>
       </div>
       <div class="newProducts">
         <swiper class="swiper-wrapper" :options="swiperProducts">
           <swiper-slide
             class="swiper-slide"
             v-for="(item, index) in firstList"
             :key="index"
           >
             <router-link :to="{ path: '/detail/' + item.id }">
               <div class="img-box">
                 <img :src="item.image" />
               </div>
               <div class="pro-info line1">{{ item.storeName }}</div>
               <div class="money font-color-red">￥{{ item.price }}</div>
             </router-link>
           </swiper-slide>
         </swiper>
       </div>
     </div>-->
    <!--   <div class="wrapper" v-if="benefit.length > 0">
          <div class="title acea-row row-between-wrapper">
            <div class="text">
              <div class="name line1">
                促销单品
                <span class="new font-color-red">PRO~</span>
              </div>
            </div>
            <router-link :to="'/promotion'" class="more">
              更多
              <span class="iconfont icon-jiantou"></span>
            </router-link>
          </div>
        </div>
   <Promotion-good :benefit="benefit"></Promotion-good>-->
    <div style="height:1.2rem;"></div>
    <div>
      <iframe
        v-if="mapKey && !isWeixin"
        ref="geoPage"
        width="0"
        height="0"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/tools/geolocation?key=' +
            mapKey +
            '&referer=myapp'
        "
      >
      </iframe>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import { getHomeData, getShare, getCityName } from "@api/public";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import cookie from "@utils/store/cookie";
import { postSignUser } from "@api/user";
import $store from "@/store";

const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const CITY = "user_city";
const MAPKEY = "mapKey";

export default {
  name: "Index1",
  components: {
    swiper,
    swiperSlide,
    GoodList,
    PromotionGood
  },
  props: {},
  data: function() {
    return {
      isDaySign: false,
      showCoupon: false,
      city: "全国",
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      bastList: [],
      firstList: [],
      info: {
        fastList: [],
        bastBanner: [],
        bastList: []
      },
      likeInfo: [],
      produceInfo: [],
      serveInfo: [],
      huaweiClub: [],
      lovely: [],
      benefit: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      //燃气公众号地址
      gasChargeUrl: ""
    };
  },
  mounted: function() {
    this.getHome();
  },
  watch: {
    menus(newVal, oldVal) {
      if (newVal.length === 0) {
        //this.getHome(); //此处公众号有时候不会加载数据的问题，老会员特别注意下菜单不能为空，不然会一直加载
      }
    }
  },
  methods: {
    getHome() {
      const that = this;
      const deptId = $store.state.app.deptId;
      getHomeData(deptId).then(res => {
        that.mapKey = res.data.mapKey;
        cookie.set(MAPKEY, that.mapKey);
        that.logoUrl = res.data.logoUrl;
        that.gasChargeUrl = res.data.gasChargeUrl;
        that.$set(that, "banner", res.data.banner);
        that.$set(that, "menus", res.data.menus);
        that.$set(that, "roll", res.data.roll);
        that.$set(that, "activity", res.data.activity);
        const activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
        that.$set(that, "info", res.data.info);
        that.$set(that, "firstList", res.data.firstList);
        that.$set(that, "bastList", res.data.bastList);
        that.$set(that, "likeInfo", res.data.likeInfo);
        that.$set(that, "produceInfo", res.data.produceInfo);
        that.$set(that, "serveInfo", res.data.serveInfo);
        that.$set(that, "huaweiClub", res.data.huaweiClub);
        that.$set(that, "lovely", res.data.lovely);
        that.$set(that, "benefit", res.data.benefit);
        postSignUser({ sign: 1 }).then(res => {
          that.isDaySign = res.data.isDaySign;
        });
        that.getWXLocation();
      });
    },
    // 获取用户信息
    signUser: function() {
      let that = this;
    },
    getWXLocation() {
      const that = this;
      if (isWeixin()) {
        wxShowLocation().then(res => {
          that.city = res;
        });
      } else {
        if (!this.mapKey)
          return this.$dialog.error(
            "暂无法使用地图定位功能，请配置您的腾讯地图key"
          );
        let loc;
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data;
            console.log("location", loc);
            if (loc && loc.module === "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
              getCityName(loc.lat, loc.lng)
                .then(res => {
                  const city = res.data.result.ad_info.city;
                  cookie.set(CITY, city);
                  that.city = city;
                })
                .catch(err => {
                  console.log(err);
                });
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              cookie.remove(CITY);
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    setOpenShare: function() {
      if (isWeixin()) {
        getShare().then(res => {
          const data = res.data.data;
          const configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}
</style>
